@if (editObject()?.key) {
  <vitamui-common-accordion [opened]="editObject().open">
    <span class="title" [ngClass]="{ empty: isEmptyObject(editObject()?.value) }">{{
      editObject().displayRule.ui.label | translate | empty | appendStar: editObject().required
    }}</span>
    <div class="title-extra v-col align-items-center justify-content-end favorite-entry">
      @if (favoriteEntry) {
        <span>{{ favoritePath | translate }}: {{ favoriteEntry[1] | empty }}</span>
      }
      @if (actionList.length) {
        <vitamui-menu-button
          overlayPos="end"
          icon="vitamui-icon-more-vert"
          menuButtonSize="small"
          menuColor="secondary"
          (click)="stopPropagation($event)"
        >
          @for (action of actionList; track action) {
            <button type="button" mat-menu-item (click)="action.handler()">{{ action.label | translate }}</button>
          }
        </vitamui-menu-button>
      }
    </div>
    <div class="content">
      <div *ngTemplateOutlet="content"></div>
    </div>
  </vitamui-common-accordion>
} @else {
  @for (column of rows; track column) {
    <div class="v-row">
      @for (child of column; track child) {
        <div class="v-col">
          @if (!child) {
            <div></div>
          }
          @if (child) {
            @switch (child.type) {
              @case (DisplayObjectType.GROUP) {
                <vitamui-common-group-editor [editObject]="child"></vitamui-common-group-editor>
              }
              @case (DisplayObjectType.LIST) {
                <vitamui-common-list-editor [editObject]="child"></vitamui-common-list-editor>
              }
              @case (DisplayObjectType.PRIMITIVE) {
                <vitamui-common-primitive-editor [editObject]="child"></vitamui-common-primitive-editor>
              }
            }
          }
        </div>
      }
    </div>
  }
  @if (editObject() && (editObject().value === null || editObject().value === undefined)) {
    <div>{{ editObject().value | empty }}</div>
  }
}

<ng-template #content>
  @for (column of rows; track column) {
    <div class="v-row">
      @for (child of column; track child) {
        <div class="v-col">
          @if (!child) {
            <div></div>
          }
          @if (child) {
            @switch (child.type) {
              @case (DisplayObjectType.GROUP) {
                <vitamui-common-group-editor [editObject]="child"></vitamui-common-group-editor>
              }
              @case (DisplayObjectType.LIST) {
                <vitamui-common-list-editor [editObject]="child"></vitamui-common-list-editor>
              }
              @case (DisplayObjectType.PRIMITIVE) {
                <vitamui-common-primitive-editor [editObject]="child"></vitamui-common-primitive-editor>
              }
            }
          }
        </div>
      }
    </div>
  }
  @if (editObject() && (editObject().value === null || editObject().value === undefined)) {
    <div>{{ editObject().value | empty }}</div>
  }
</ng-template>

<ng-template #removeDialog>
  <vitamui-dialog-header
    [subhead]="'ARCHIVE_UNIT.DIALOGS.REMOVE.TITLE' | translate"
    [title]="'ARCHIVE_UNIT.DIALOGS.REMOVE.CONTENT' | translate"
  ></vitamui-dialog-header>
  <mat-dialog-actions>
    <button [matDialogClose]="true" class="btn primary btn-confirm-dialog">
      {{ 'ARCHIVE_UNIT.DIALOGS.REMOVE.BUTTONS.CONFIRM' | translate }}
    </button>
    <button matDialogClose class="btn link cancel cancel-popup">{{ 'ARCHIVE_UNIT.DIALOGS.REMOVE.BUTTONS.CANCEL' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
